angular.module('core')
  .service('customerApi', [
    '$cachedResource',
    'transformResponse',
    'policy',
    'nameFilter',
    '$window',
    'taggable',
    function($cachedResource, $transformResponse, $policy, $nameFilter, $window, taggable) {
      var self = this;

      var customerMapping = function(customer) {
        customer.name = $nameFilter(customer);

        if (customer.is_district_admin) {
          customer.role = 'districtAdmin';
        } else if (customer.is_school_admin && customer.school_admin_mode !== 2) {
          customer.role = 'schoolAdmin';
        } else if (customer.is_consumer_guardian) {
          customer.role = 'guardian';
        } else {
          customer.role = 'teacher';
        }

        // set policy rules
        customer.policy = $policy[customer.role];

        // add tag related functionality
        taggable(customer);

        // add settings permissions function
        customer.getSettingsPermissions = function() {
          var canEdit = typeof this.district_provision_uid !== 'undefined' &&
                  typeof this.provision_uid !== 'undefined' &&
                  this.edit_locked === false;

          return {
            canEdit: canEdit
          };
        };

        customer.isAdmin = function() {
          return this.role === 'schoolAdmin' || this.role === 'districtAdmin';
        };

        customer.isDistrictAdmin = function() {
            return this.role === 'districtAdmin';
        };

        customer.isGuardian = function() {
          return this.role === 'guardian';
        };

        customer.isSchoolAdmin = function() {
            return this.role === 'schoolAdmin';
        };

        customer.isTeacher = function() {
          return this.role === 'teacher';
        };

        // Only works for teacher level :( Admins never get the field
        customer.hasClassrooms = function() {
          return this.classroom_ids && this.classroom_ids.length;
        };

        // set custom dimension in google analytics
        if ($window.ga) {
          $window.ga('set', 'dimension1', customer.role);
        }
      };

      var CustomerNavigation = $cachedResource('CustomerNavigation', '/n/customer_info', {
        id: '@id'
      }, {
        get: {
          cache: true,
          url: '/n/customer_info',
          method: 'GET',
          isArray: false,
          transformResponse: function(body) {
            return $transformResponse.transformNavigationGet('customer', body, customerMapping);
          }
        }
      });


      /**************************************************************/
      /*                          Api                               */
      /**************************************************************/

      self.getCustomer = function() {
        var params = {};
        return CustomerNavigation.get(params);
      };
    }
  ]);
